import axios from 'axios';
import { GET_COOPERATION } from './types';
import { API_HOST } from '../vars';

export const getCooperation = () => dispatch => {
    axios
        .get(`${API_HOST}/cooperation/get`)
        .then(({ data: { section, data } }) => {
            dispatch({
                type: GET_COOPERATION,
                payload: {
                    loaded: true,
                    section,
                    data
                }
            });
        })
        .catch(error => console.log(error));
};
